import defaultCode from "./defaultCode";
import lesson from "./lesson";
import test from "./test";

export default {
    name: "Check Balance",
    defaultCode,
    lesson,
    test,
    difficulty: 1,
};
